<ng-template [ngTemplateOutlet]="siteKeyFilterTemplate"></ng-template>

@if (siteKeySearchLookup?.searched) {
<gtapp-gt-custom-table
  [deskTopTableData]="searchedSiteKeyData?.data"
  [desktopTableDetails]="searchedSiteKeyTableDetail"
  [otherParams]="otherParamsSiteKey"
  (paginationChange)="onChangeSiteKeyTablePagination($event)"
  (rowClick)="onSiteRedirect($event)"
>
</gtapp-gt-custom-table>
} @else {
<div class="d-flex my-4">
  @if (selectedGroupedClient?.id) {
  <span (click)="selectedGroupedClient={};selectedGroupedSite = {}">
    <span class="cursor-pointer text-decoration-underline">
      {{ selectedGroupedClient?.name }}</span
    >
  </span>
  } @if (selectedGroupedSite?.id) {
  <span (click)="selectedGroupedSite = {}">
    >
    <span class="cursor-pointer text-decoration-underline">
      {{ selectedGroupedSite?.name }}</span
    >
  </span>
  }
</div>
<div class="row row-cols-1 row-cols-lg-2">
  <div class="col">
    <gtapp-gt-custom-table
      [deskTopTableData]="
          selectedGroupedClient?.id
            ? groupedSiteListData
            : groupedClientListData
        "
      [desktopTableDetails]="[
          {
            header:  selectedGroupedClient?.id ? 'Site' : 'Client',
            name: 'name',
            searchKey: 'name',
            sortKey: 'name',
          },
          { header: 'Key Count', name: 'key_count', sortKey: 'key_count' },
        ]"
      [otherParams]="selectedGroupedClient?.id
            ? otherParamsGroupedSiteList
            : otherParamsGroupedClientList"
      (searchColumn)="onSearchGroupedSiteKeyTable($event)"
      (sortColumn)="onSortGroupedSiteKeyTable($event)"
      (paginationChange)="onChangeGroupedSiteKeyTablePagination($event)"
      (rowClick)="onGroupedRowClick($event)"
    >
    </gtapp-gt-custom-table>
  </div>
  @if (selectedGroupedSite?.id) {
  <div class="col p-3">
    <ng-container>
      <gtapp-site-keys
        [selectedSite]="selectedGroupedSite"
        [showManageOption]="true"
        (updateSiteInfo)="siteKeyListUpdated($event)"
      ></gtapp-site-keys>
    </ng-container>
  </div>
  }
</div>
}

<ng-template #siteKeyFilterTemplate let-siteKeyFilterTempRef="dialogRef">
  <div class="d-flex flex-wrap gap-2 mb-3">
    <div>
      <div class="input-group">
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            id="searchSiteKeys"
            autofocus
            placeholder="Key ID/Name"
            [(ngModel)]="siteKeySearchLookup.searchStr"
          />
          <label for="searchSiteKeys">Key ID/Name</label>
        </div>
        @if (siteKeySearchLookup?.searchStr) {
        <span class="input-group-text" (click)="editField('searchStr')">
          <i class="fa-solid fa-xmark"></i>
        </span>
        }
      </div>
    </div>

    @if (siteKeySearchLookup?.site_data?.id) {
    <dl>
      <dt>Site</dt>
      <dd (click)="editField('site')" class="link-edit">
        {{ siteKeySearchLookup?.site_data?.company_name }} @if
        (siteKeySearchLookup?.site_data?.company?.company_name) {
        <span>
          [{{ siteKeySearchLookup?.site_data?.company?.company_name }}]
        </span>
        }
      </dd>
    </dl>
    } @else {
    <div [class.opacity-50]="siteKeySearchLookup?.site_data?.disabled">
      <gtapp-auto-complete
        [data]="siteListData"
        placeHolder="Site (Optional)"
        searchKeyword="company_name"
        [initialValue]="siteKeySearchLookup?.site?.company_name"
        [itemTemplate]="siteTemplate"
        (inputChanged)="onSiteSearch($event)"
        (selected)="siteKeySearchLookup.site_data = $event"
        inputId="siteId"
        [enableCloseOption]="true"
        (fieldCleared)="editField('site')"
        (inputFocused)="inputFocused('site')"
      >
      </gtapp-auto-complete>
      <ng-template #siteTemplate let-item>
        @if (item?.key === 0) {
        <div>Create New Site</div>
        } @else {
        <div>
          <div class="fw-medium">
            {{ item?.company_name }} [{{ item?.company?.company_name }}]
          </div>

          <div class="small-font text-secondary">
            {{ item?.address?.full_address }}
          </div>
        </div>
        }
      </ng-template>
    </div>
    } @if (siteKeySearchLookup?.client_data?.id) {
    <dl>
      <dt>Site</dt>
      <dd (click)="editField('site')" class="link-edit">
        {{ siteKeySearchLookup?.client_data?.company_name }} @if
        (siteKeySearchLookup?.client_data?.company?.company_name) {
        <span>
          [{{ siteKeySearchLookup?.client_data?.company?.company_name }}]
        </span>
        }
      </dd>
    </dl>
    } @else {
    <div [class.opacity-50]="siteKeySearchLookup?.client_data?.disabled">
      <gtapp-auto-complete
        [data]="clientListData"
        placeHolder="Client (Optional)"
        searchKeyword="company_name"
        [itemTemplate]="clientLookupTemplate"
        (inputChanged)="onClientSearch($event)"
        [initialValue]="siteKeySearchLookup?.client?.company_name"
        (selected)="siteKeySearchLookup.client_data = $event"
        [enableCloseOption]="true"
        inputId="clientLookupId"
        (fieldCleared)="editField('client')"
        (inputFocused)="inputFocused('client')"
      >
      </gtapp-auto-complete>
      <ng-template #clientLookupTemplate let-item>
        <div>{{ item?.company_name }}</div>
      </ng-template>
    </div>
    }

    <button
      class="btn btn-primary btn-lg px-lg-5"
      [disabled]="
        !(
          siteKeySearchLookup?.searchStr ||
          siteKeySearchLookup?.site_data?.id ||
          siteKeySearchLookup?.client_data?.id
        )
      "
      (click)="onSiteKeySearch()"
    >
      Search
    </button>

    @if ( siteKeySearchLookup?.searchStr || siteKeySearchLookup?.site_data?.id
    || siteKeySearchLookup?.client_data?.id ) {
    <button
      class="btn btn-outline-danger btn-lg px-lg-5"
      (click)="onSiteKeySearch(true)"
    >
      Reset
    </button>
    }
  </div>
</ng-template>
